import client from './client';
import {
  ApiResponse,
  ServiceResponse,
  MemberResponse
} from '../types';

export const serviceApi = {
  getServices: () => 
    client.get<ApiResponse<ServiceResponse[]>>('/api/v1/admin/services'),
    
  getService: (serviceCode: string) => 
    client.get<ApiResponse<ServiceResponse>>(`/api/v1/admin/services/${serviceCode}`),
    
  createService: (data: { code: string; name: string; description?: string }) => 
    client.post<ApiResponse<ServiceResponse>>('/api/v1/admin/services', data),
    
  updateService: (serviceCode: string, data: { name: string; description?: string }) => 
    client.patch<ApiResponse<ServiceResponse>>(`/api/v1/admin/services/${serviceCode}`, data),

  deleteService: (serviceCode: string) =>
    client.delete<ApiResponse<void>>(`/api/v1/admin/services/${serviceCode}`),
    
  // Requirement: includeRemoved param added
  getMembers: (serviceCode: string, includeRemoved: boolean = false) => 
    client.get<ApiResponse<MemberResponse[]>>(`/api/v1/admin/services/${serviceCode}/members`, {
      params: { includeRemoved }
    }),
    
  addMember: (serviceCode: string, data: { userId: number; role: string }) => 
    client.post<ApiResponse<MemberResponse>>(`/api/v1/admin/services/${serviceCode}/members`, data),
    
  updateMember: (serviceCode: string, userId: number, data: { role: string }) => 
    client.patch<ApiResponse<MemberResponse>>(`/api/v1/admin/services/${serviceCode}/members/${userId}`, data),
    
  removeMember: (serviceCode: string, userId: number) => 
    client.delete<ApiResponse<void>>(`/api/v1/admin/services/${serviceCode}/members/${userId}`),
};
